import { number, ord } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { CalendarService, StructuredDate, StructuredTime, TimeService } from '@optimus-web/core';

interface CorrectionDayPolicyProps {
    startDate: StructuredDate;
    getCalendarService: () => CalendarService;
    autofillDayDifference?: number;
    minDayDifference?: number;
    maxDayDifference?: number;
}

export type CorrectionDayPolicyFunction = (props: CorrectionDayPolicyProps) => {
    newStartDate: StructuredDate | null;
    newEndDate: StructuredDate | null;
};

interface CorrectionHourPolicyProps {
    startDateTime: StructuredTime;
    getTimeService: () => TimeService;
    autofillHourDifference?: number;
    minHourDifference?: number;
    maxHourDifference?: number;
}

export type CorrectionHourPolicyFunction = (props: CorrectionHourPolicyProps) => {
    newStartDateTime: StructuredTime | null;
    newEndDateTime: StructuredTime | null;
};

export const setEarliestAcceptableEndDate: CorrectionDayPolicyFunction = ({
    startDate,
    getCalendarService,
    autofillDayDifference = 0,
    minDayDifference = 0,
    maxDayDifference = Number.POSITIVE_INFINITY,
}) => {
    const { addDays } = getCalendarService();
    const numberClamp = ord.clamp(number.Ord);
    const dayCountToAdd = pipe(maxDayDifference, numberClamp(autofillDayDifference, minDayDifference));
    const newEndDate = addDays(startDate, dayCountToAdd);
    return { newStartDate: startDate, newEndDate };
};

export const setEarliestAcceptableEndDateTime: CorrectionHourPolicyFunction = ({
    startDateTime,
    getTimeService,
    autofillHourDifference = 0,
    minHourDifference = 0,
    maxHourDifference = Number.POSITIVE_INFINITY,
}) => {
    const { addHours } = getTimeService();
    const numberClamp = ord.clamp(number.Ord);
    const hourCountToAdd = pipe(maxHourDifference, numberClamp(autofillHourDifference, minHourDifference));
    const newEndDateTime = addHours(startDateTime, hourCountToAdd);
    return { newStartDateTime: startDateTime, newEndDateTime };
};
